import React from "react";
import "./Header.css";
import phone from "../images/phone.png";

const Header = () => {
  return (
    <div className="header">
      <h3>
        <b>
          For Booking:
          <img src={phone} alt="" />
          <a
            href="https://wa.me/76878378?text=Hello%20there%20!%20I%20would%20like%20some%20details%20about%20the%20cross%20country%20flight."
            style={{ color: "black" }}
          >
            +961 76 878 378
          </a>
        </b>{" "}
      </h3>
    </div>
  );
};

export default Header;
